'use client'

import React from 'react'
import { onBreadcrumbClick, onLanguageSelect } from '@navikt/nav-dekoratoren-moduler'
import { store } from '@/app/_components/store/store'
import { AppLocale, AreaId, basePath, currentArea, locales } from '@/urls'

export const DecoratorClient = () => {
    const actions = store.useActions()

    React.useEffect(() => {
        actions.HYDRATE_FROM_SESSION()
    }, [])

    React.useEffect(() => {
        onBreadcrumbClick((breadcrumb) => {
            const withoutBasePath = basePath && breadcrumb.url.startsWith(basePath) ? breadcrumb.url.slice(basePath.length) : breadcrumb.url
            const parts = withoutBasePath.split('/').filter(Boolean)
            if (locales.includes(parts[0] as AppLocale)) parts.shift()
            const segment = currentArea ?? (parts.shift() as AreaId)
            const view = parts[0]

            if (segment == 'arbeidstaker') {
                actions.SET_ARBEIDSTAKER_VIEW((view as 'arbeidsforhold') || 'arbeidstaker')
            }

            if (segment == 'arbeidsgiver') {
                actions.SET_ARBEIDSGIVER_VIEW((view as 'arbeidsforhold' | 'arbeidssted') || 'hovedenhet')
            }

            if (segment == 'samarbeidspartner') {
                actions.SET_SAMARBEIDSPARTNER_VIEW(view === 'arbeidsforhold' ? 'arbeidsforhold' : 'soek')
            }
        })
        onLanguageSelect((language) => {
            window.location.assign(language.url!)
        })
    }, [])

    return null
}
